"use strict";

module.exports = function () {
  return this.opts.filterByColumn ? JSON.stringify(this.query) : this.query;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/q.js
// module id = 2183
// module chunks = 0